import { createActionConst } from '../../../utils/action.utils';

const MEETING_DASHBOARD_NAMESPACE = 'LIVE_MEETING';

export const INITIAL_MEETING_DASHBOARD_PAGE = createActionConst(MEETING_DASHBOARD_NAMESPACE, 'INITIAL_HOME_PAGE');
export const MEETING_SHORTCUT_CREATE_FOLDER_MEETING_DASHBOARD_PAGE = createActionConst(
  MEETING_DASHBOARD_NAMESPACE,
  'TEAM_FILE_CREATE_FOLDER_MEETING_DASHBOARD_PAGE',
);

export const MEETING_SHORTCUT_SELECTED_FOLDER_MEETING_DASHBOARD_PAGE = createActionConst(
  MEETING_DASHBOARD_NAMESPACE,
  'TEAM_FILE_SELECTED_FOLDER_MEETING_DASHBOARD_PAGE',
);
export const MEETING_SHORTCUT_DELETE_FILE_MEETING_DASHBOARD_PAGE = createActionConst(
  MEETING_DASHBOARD_NAMESPACE,
  'TEAM_FILE_DELETE_FILE_MEETING_DASHBOARD_PAGE',
);

export const MEETING_SHORTCUT_CREATE_FILE_MEETING_DASHBOARD_PAGE = createActionConst(
  MEETING_DASHBOARD_NAMESPACE,
  'TEAM_FILE_CREATE_FILE_MEETING_DASHBOARD_PAGE',
);

export const MEETING_SHORTCUT_UNSELECTED_FOLDER_MEETING_DASHBOARD_PAGE = createActionConst(
  MEETING_DASHBOARD_NAMESPACE,
  'TEAM_FILE_UNSELECTED_FOLDER_MEETING_DASHBOARD_PAGE',
);

export const MEETING_SHORTCUT_UPDATE_PAGE = createActionConst(
  MEETING_DASHBOARD_NAMESPACE,
  'MEETING_SHORTCUT_UPDATE_PAGE',
);
export const MEETING_SHORTCUT_DELETE_PAGE = createActionConst(
  MEETING_DASHBOARD_NAMESPACE,
  'MEETING_SHORTCUT_DELETE_PAGE',
);
